module.exports = __webpack_public_path__ + "img/terroir-choppy-4-mobile.4293e4a9.jpg";